export enum ProviderType {
  SIMPLE = 'simple',
  LAUNCH_DARKLY = 'launch_darkly',
}
